// styles
import styled from 'styled-components';
import { useCallback } from 'react';
import {
  useSoFormStepsApi,
  useSoFormStepsState,
} from 'refactored/features/soForm/SoForm.context';
import { useTranslation } from 'react-i18next';

const CustomCheckbox = styled.input`
  border: 1px solid green;
`;

const Label = styled.div`
  height: 16px;

  /* 14px/regular */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  /* identical to box height, or 114% */

  /* grey / 700 */
  user-select: none; /* Standard syntax */

  color: #54708c;
`;

const SoEconomyWindowCheckbox = ({ className, candidate }) => {
  const stepsState = useSoFormStepsState();
  const stepsApi = useSoFormStepsApi();
  const { t } = useTranslation('Catalog');

  const isLoading = stepsState.price.isUpdatingPrice;
  const use6hoursWindow = stepsState.price.use6hoursWindow;

  const setUse6hoursWindow = useCallback(() => {
    if (isLoading) return;
    stepsApi.setUse6hoursWindow({ value: !use6hoursWindow, candidate });
  }, [candidate, isLoading, stepsApi, use6hoursWindow]);

  //   pickup

  return (
    <div className={className}>
      <CustomCheckbox
        type="checkbox"
        checked={use6hoursWindow}
        onChange={setUse6hoursWindow}
      />
      <Label onClick={setUse6hoursWindow}>
        {t('price.reduce_windows_to_6_hours')}
      </Label>
    </div>
  );
};

export default styled(SoEconomyWindowCheckbox)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 12px;

  height: 20px;
  /* border: 1px solid red; */
`;
